export default {
  // NewRichTextEditor
  writeSomething: 'Write something...',
  increaseColumnWidth: 'Add 10% to column width',
  decreaseColumnWidth: 'Remove 10% from column width',
  insertTable: 'Insert 2x2 table',
  deleteTable: 'Delete table',
  addColumnLeft: 'Add column to the left',
  addColumnRight: 'Add column to the right',
  addRowBelow: 'Add row below',
  addRowAbove: 'Add row above',
  deleteRow: 'Delete Row',
  deleteColumn: 'Delete Column',

  // ContainerRichTextKlv3
  unsavedChangesMessage: 'Are you sure you want to close? Unsaved data will be lost.',
  confirmationRequired: 'Confirmation Required',
  yesClose: 'Yes, close',
  listMode: 'Insert as a list',
  listModeHelp: 'Each line of the text is saved as a separate record.',
  listModeCount: 'Records to create: {count}',
  listModeCreated: 'Records created: {count}',
}
